import {Outlet} from 'react-router-dom'

import useStore from 'base/store'
import styles from './Documents.module.scss'
import {useGetProjectConditions} from 'modules/project'
import {RequestTagType, useGetAML} from 'modules/request'
import {Loader} from 'common/components'
import {
  DocumentsPanel,
  useGetDocuments,
  useProjectUuid,
  useGetChatFiles,
} from '.'

interface DocumentsProps {
  isRequest?: boolean
  tag?: RequestTagType
}

export default function Documents({isRequest, tag}: DocumentsProps) {
  const role = useStore((state) => state.role)
  const projectUuid = useProjectUuid(isRequest, tag)
  const {data: documents} = useGetDocuments(projectUuid)
  const {data: aml} = useGetAML(projectUuid, !role?.user)
  const {data: chatFiles} = useGetChatFiles(projectUuid)
  const {data: conditions} = useGetProjectConditions(projectUuid)

  const hasDrawdowns = documents?.some(
    (document) => document?.model?.type === 'drawdown'
  )

  return (
    <div className={styles.root}>
      <DocumentsPanel isRequest={isRequest} hasDrawdowns={hasDrawdowns} />
      { documents && chatFiles && conditions &&
        (
          (role?.user ===true) || aml
        )
        ? 
        <Outlet /> : <Loader />
      }
    </div>
  )
}
